/**
 * Client-side mirror of `CustomEndpointCreate.base_url` on the api
 * (TRA-1433): https everywhere, and plain http as well on enterprise
 * installs, whose model servers run inside the cluster
 * (`http://<svc>.<ns>.svc.cluster.local:8000/v1`).
 */

import type { Deployment } from '@/config'

export function endpointUrlSchemes(deployment: Deployment): readonly string[] {
  return deployment === 'enterprise' ? ['https://', 'http://'] : ['https://']
}

export function isEndpointUrlAllowed(url: string, deployment: Deployment): boolean {
  return endpointUrlSchemes(deployment).some((scheme) => url.startsWith(scheme))
}

/** The hint under the endpoint URL field. */
export function endpointUrlHint(deployment: Deployment): string {
  const schemes = deployment === 'enterprise' ? 'http or https' : 'https only'
  return `OpenAI-compatible base URL of the deployed model (${schemes}).`
}
